import * as types from '../types';
import moment from 'moment';
import update from 'immutability-helper';
import { useSelector } from 'react-redux';
import {
    VIEW_MODE,
    EDIT_MODE,
    STATUS_MAP,
    STATUS_SAVED,
} from '@Utils/constants';

const initialTitle = 'Background Check';

export const initialDetailForm = {
    employeeId: 0,
    id: '',
    applicantID: '',
    positionAppliedID: '',
    applicantType: '',
    status: '',
    remarks: '',
    remarksCharCount: 256,
    characterReference: [],
}

const defaultState = {
    title: 'Background Check',
    mode: VIEW_MODE,
    loading: true,
    hasLoadedData: false,
    initialSubmit: true,
    temporarydisable: undefined,
    detailForm: { ...initialDetailForm },
    emailTemplate: { subject: '', body: '' },
    statusInitialVal: '',
    charRefInitialVal: [],
    alert: {
        show: false,
        title: 'Create success',
        content: 'Successfuly created record.',
        confirmLabel: 'Ok',
    },
    confirmModal: {
        show: false,
        title: 'Confirm Cancellation',
        message: 'Do you want to cancel this Background Check?',
        confirmData: null, // Set the data to be passed in confirm
        onConfirm: () => { },
        onClose: () => { },
    }
}

export default function detailReducer(state = defaultState, action) {
    switch (action.type) {
        case types.CHG_FIELD:
        case types.CHG_STATUS:
        case types.CHG_EMPLOYEE_ID:
            return update(state, {
                detailForm: {
                    [action.payload.name]: { $set: action.payload.data }
                }
            });
        case types.RESET_ADD_DATA:
            return update(state, {
                detailForm: { $set: { ...initialDetailForm, employeeId: action.payload } },
                alert: { $set: defaultState.alert }
            });
        case types.UPD_ADD_ALERT:
            return update(state, {
                alert: { $set: action.payload }
            });
        case types.UPD_ADD_MEMO_CHAR_COUNT:
            return update(state, {
                detailForm: {
                    memoCharCount: { $set: state.detailForm.memoCharCount - 1 }
                }
            });
        case types.UPD_DETAIL_MODE:
            let mode = action.payload;
            switch (mode) {
                case EDIT_MODE:
                    mode = EDIT_MODE;
                    break;
                default:
                    mode = VIEW_MODE;
                    break;
            }
            return update(state, {
                mode: { $set: mode }
            })
        case types.SET_DETAIL_DATA:
            let data = action.payload;
            let editable = false;
            // if (STATUS_MAP[data.backgroundCheckResultApproval] === STATUS_SAVED) {
            //     editable = true;
            //     initialMode = EDIT_MODE;
            // }
            return update(state, {
                title: { $set: initialTitle },
                isEditable: { $set: editable },
                detailForm: { $set: data },
                alert: { $set: defaultState.alert }
            });
        case types.UPD_DETAIL_REMARKS:
            return update(state, {
                detailForm: {
                    characterReference: {
                        [action.payload.index]: {
                            remarks: { $set: action.payload.value }
                        }
                    }
                }
            });
        case types.HIDE_ADD_ALERT:
            return update(state, {
                alert: {
                    show: { $set: false }
                }
            });
        case types.SHOW_CONFIRM_MODAL:
            return update(state, {
                confirmModal: {
                    show: { $set: action.payload },
                }
            });
        case types.UPDATE_CONFIRM_MODAL:
            return update(state, {
                confirmModal: { $set: action.payload }
            })
        case types.HAS_DETAIL_LOADED:
            return update(state, {
                hasLoadedData: { $set: action.payload }
            });
        case types.UPDATE_INITIAL_SUBMIT_STATE:
            return update(state, {
                initialSubmit: { $set: action.payload }
            });
        case types.UPDATE_BACKGROUND_STATUS:
            return update(state, {
                detailForm: {
                    status: { $set: action.payload }
                }
            });
        case types.UPDATE_TEMPORARY_DISABLE:
            return update(state, {
                temporarydisable: { $set: action.payload }
            });
        case types.SET_CHARACTER_REFERENCE_INITIAL_VALUES:
            return update(state, {
                charRefInitialVal: { $set: action.payload }
            })
        case types.SET_STATUS_INITIAL_VALUES:
            return update(state, {
                statusInitialVal: { $set: action.payload }
            })
        case types.SET_DETAIL_EMAIL_TEMPLATE:
                return update(state, {
                    emailTemplate: { $set: action.payload }
                });
        default:
            return state;
    }
};